export default __webpack_public_path__ + "static/media/news.23d2be30.png";